import React from 'react';
import CreateOrderForm from './CreateOrderForm';

class CreateOrderPage extends React.Component {
  render() {
    return (
      <div>
        <CreateOrderForm />
      </div>
    );
  }
}

export default CreateOrderPage;



// WEBPACK FOOTER //
// ./src/components/order/CreateOrderPage.js